/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Provider } from '../models/Provider';
import { ScalarOperators } from '../models/ScalarOperators';

export class CloudProviderCondition {
  'operator': ScalarOperators;
  'cloudProviders': Array<Provider>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "operator",
      "baseName": "operator",
      "type": "ScalarOperators",
      "format": ""
    },
    {
      "name": "cloudProviders",
      "baseName": "cloudProviders",
      "type": "Array<Provider>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CloudProviderCondition.attributeTypeMap;
  }

  public constructor() {
  }
}



